export const GLOBAL_SANDBOXES_PATH = '/sandboxes';
export const GLOBAL_SANDBOX_DETAIL_PATH =
  '/sandboxes/:entityName/:sandboxId/:tab(overview|logs)?';

export const ENTITY_SANDBOXES_PATH = '/:entityName/sandboxes';
export const ENTITY_SANDBOX_DETAIL_PATH =
  '/:entityName/sandboxes/:sandboxId/:tab(overview|logs)?';
